import parametresExploitationGroupeApi from '@/api/parametres-exploitation-groupe.api'

const getDefaultState = () => {
  return {
    repartitionParametresTypeExploitation: {},
    repartitionParametresTypeProduction: {},
    repartitionParametresPotentielSol: {},
    repartitionParametresRessourceEffluent: {},
    repartitionParametresTypeStockage: {}
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    repartitionParametresTypeExploitation (state) {
      return state.repartitionParametresTypeExploitation
    },
    repartitionParametresTypeProduction (state) {
      return state.repartitionParametresTypeProduction
    },
    repartitionParametresPotentielSol (state) {
      return state.repartitionParametresPotentielSol
    },
    repartitionParametresRessourceEffluent (state) {
      return state.repartitionParametresRessourceEffluent
    },
    repartitionParametresTypeStockage (state) {
      return state.repartitionParametresTypeStockage
    },
  },

  mutations: {
    UPDATE_REPARTITION_PARAMETRES_TYPE_EXPLOITATION (state, repartitionParametresTypeExploitation) {
      state.repartitionParametresTypeExploitation = repartitionParametresTypeExploitation
    },
    UPDATE_REPARTITION_PARAMETRES_TYPE_PRODUCTION (state, repartitionParametresTypeProduction) {
      state.repartitionParametresTypeProduction = repartitionParametresTypeProduction
    },
    UPDATE_REPARTITION_PARAMETRES_POTENTIEL_SOL (state, repartitionParametresPotentielSol) {
      state.repartitionParametresPotentielSol = repartitionParametresPotentielSol
    },
    UPDATE_REPARTITION_PARAMETRES_RESSOURCE_EFFLUENT (state, repartitionParametresRessourceEffluent) {
      state.repartitionParametresRessourceEffluent = repartitionParametresRessourceEffluent
    },
    UPDATE_REPARTITION_PARAMETRES_TYPE_STOCKAGE (state, repartitionParametresTypeStockage) {
      state.repartitionParametresTypeStockage = repartitionParametresTypeStockage
    }
  },

  actions: {
    getRepartitionTypeExploitationGroupe ({ commit, rootGetters }, codesRegions) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return parametresExploitationGroupeApi.getRepartitionTypeExploitationGroupe(username, codesRegions)
        .then(response => {
          commit('UPDATE_REPARTITION_PARAMETRES_TYPE_EXPLOITATION', response)
        })
    },
    getRepartitionTypeProductionGroupe ({ commit, rootGetters }, codesRegions) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return parametresExploitationGroupeApi.getRepartitionTypeProductionGroupe(username, codesRegions)
        .then(response => {
          commit('UPDATE_REPARTITION_PARAMETRES_TYPE_PRODUCTION', response)
        })
    },
    getRepartitionPotentielSolGroupe ({ commit, rootGetters }, codesRegions) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return parametresExploitationGroupeApi.getRepartitionPotentielSolGroupe(username, codesRegions)
        .then(response => {
          commit('UPDATE_REPARTITION_PARAMETRES_POTENTIEL_SOL', response)
        })
    },
    getRepartitionRessourceEffluentGroupe ({ commit, rootGetters }, codesRegions) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return parametresExploitationGroupeApi.getRepartitionRessourceEffluentGroupe(username, codesRegions)
        .then(response => {
          commit('UPDATE_REPARTITION_PARAMETRES_RESSOURCE_EFFLUENT', response)
        })
    },
    getRepartitionTypeStockageGroupe ({ commit, rootGetters }, codesRegions) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return parametresExploitationGroupeApi.getRepartitionTypeStockageGroupe(username, codesRegions)
        .then(response => {
          commit('UPDATE_REPARTITION_PARAMETRES_TYPE_STOCKAGE', response)
        })
    }
  }
}

export default module
